var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_vm._v(" 404 - Component "),_c('b',[_vm._v(_vm._s(_vm.componentName))]),_vm._v(" NOT FOUND ! ")])}
var staticRenderFns = []

export { render, staticRenderFns }